import React from "react";
import { X, Search } from "lucide-react";

const SearchPanel = ({ searchText, setSearchText }) => {
  const handleSearch = () => {
    if (!searchText.trim()) return;
    // Optionally handle search logic here
  };

  const handleClear = () => {
    setSearchText("");
  };

  return (
    <div className="bg-black py-4 px-6 mb-10">
      <div className="flex items-center bg-[#D9D9D9] rounded-lg px-3 py-2">
        <input
          type="text"
          placeholder="Search"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          className="flex-grow bg-[#D9D9D9] text-black placeholder-black-400 focus:outline-none text-sm"
        />

        {searchText?.length > 0 && (
          <button
            onClick={handleClear}
            className="mr-2 text-gray-400 hover:text-gray-200"
          >
            <X size={20} />
          </button>
        )}
        <button
          onClick={handleSearch}
          className="text-gray-400 hover:text-gray-200"
        >
          <Search size={20} />
        </button>
      </div>
    </div>
  );
};

export default SearchPanel;
